import { config, handleResponse } from '../../_helpers';

export const calendarService = {
    createHoliday,
    createWorkDays,
    getAllHoliday,
    getHoliday,
    getAllWorkingDays,
    getWorkingDayByBranch,
    updateHoliday,
    updateWorkingDays,
    deleteHoliday,
    deleteWorkingDays,
    readLocalHolidaybyBranch
};

function readLocalHolidaybyBranch(branch) {
    const requestOptions = {
        method: 'GET'
    };
    return fetch(`${config.apiUrl}/Calendar/readLocalHolidaybyBranch?branchCode=${branch}`, requestOptions).then(handleResponse);
}
function getAllHoliday(branch) {
    const requestOptions = {
        method: 'GET'
    };
    if (branch) {
        return fetch(`${config.apiUrl}/Calendar/getAllHoliday?branchCode=${branch}`, requestOptions).then(handleResponse);
    }
    else {
        return fetch(`${config.apiUrl}/Calendar/getAllHoliday`, requestOptions).then(handleResponse);
    }
}
function getHoliday(id) {
    const requestOptions = {
        method: 'GET'
    };
    return fetch(`${config.apiUrl}/Calendar/getHoliday/${id}`, requestOptions).then(handleResponse);
}
function getAllWorkingDays(branch) {
    const requestOptions = {
        method: 'GET'
    };
    if (branch) {
        return fetch(`${config.apiUrl}/Calendar/getAllWorkingDays?branchCode=${branch}`, requestOptions).then(handleResponse);
    }
    else {
        return fetch(`${config.apiUrl}/Calendar/getAllWorkingDays`, requestOptions).then(handleResponse);
    }
}
function getWorkingDayByBranch(branch) {
    const requestOptions = {
        method: 'GET'
    };
    return fetch(`${config.apiUrl}/Calendar/getWorkingDayByBranch/${branch}`, requestOptions).then(handleResponse);
}
function createHoliday(payload) {
    const requestOptions = {
        method: 'POST',
        body: JSON.stringify(payload),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    return fetch(`${config.apiUrl}/Calendar/createHoliday`, requestOptions).then(handleResponse);
}
function createWorkDays(payload) {
    const requestOptions = {
        method: 'POST',
        body: JSON.stringify(payload),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    return fetch(`${config.apiUrl}/Calendar/createWorkDays`, requestOptions).then(handleResponse);
}
function updateHoliday(payload, id) {
    const requestOptions = {
        method: 'PUT',
        body: JSON.stringify(payload),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    return fetch(`${config.apiUrl}/Calendar/updateHoliday/${id}`, requestOptions).then(handleResponse);
}
function updateWorkingDays(payload) {
    const requestOptions = {
        method: 'PUT',
        body: JSON.stringify(payload),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    return fetch(`${config.apiUrl}/Calendar/updateWorkingDays`, requestOptions).then(handleResponse);
}
function deleteHoliday(id) {
    const requestOptions = {
        method: 'DELETE',
        // body: JSON.stringify(id),
        // headers: {
        //     "Content-type": "application/json; charset=UTF-8"
        // }
    };
    return fetch(`${config.apiUrl}/Calendar/deleteHoliday/${id}`, requestOptions).then(handleResponse);
}
function deleteWorkingDays(id) {
    const requestOptions = {
        method: 'DELETE',
        body: JSON.stringify(id),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    return fetch(`${config.apiUrl}/Calendar/deleteWorkingDays`, requestOptions).then(handleResponse);
}